"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/*
  The MIT License

  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
var range_1 = tslib_1.__importDefault(require("lodash/range"));
var react_1 = tslib_1.__importDefault(require("react"));
var core_1 = require("@jsonforms/core");
var map_1 = tslib_1.__importDefault(require("lodash/map"));
var ArrayToolbar_1 = require("./ArrayToolbar");
var ExpandPanelRenderer_1 = tslib_1.__importDefault(require("./ExpandPanelRenderer"));
var merge_1 = tslib_1.__importDefault(require("lodash/merge"));
var MaterialArrayLayout = /** @class */ (function (_super) {
    tslib_1.__extends(MaterialArrayLayout, _super);
    function MaterialArrayLayout() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            expanded: null
        };
        _this.innerCreateDefaultValue = function () { return core_1.createDefaultValue(_this.props.schema); };
        _this.handleChange = function (panel) { return function (_event, expanded) {
            _this.setState({
                expanded: expanded ? panel : false
            });
        }; };
        _this.isExpanded = function (index) {
            return _this.state.expanded === core_1.composePaths(_this.props.path, "" + index);
        };
        return _this;
    }
    MaterialArrayLayout.prototype.render = function () {
        var _this = this;
        var _a = this.props, data = _a.data, path = _a.path, schema = _a.schema, uischema = _a.uischema, errors = _a.errors, addItem = _a.addItem, renderers = _a.renderers, cells = _a.cells, label = _a.label, required = _a.required, rootSchema = _a.rootSchema, config = _a.config, uischemas = _a.uischemas;
        var appliedUiSchemaOptions = merge_1.default({}, config, this.props.uischema.options);
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(ArrayToolbar_1.ArrayLayoutToolbar, { label: core_1.computeLabel(core_1.isPlainLabel(label) ? label : label.default, required, appliedUiSchemaOptions.hideRequiredAsterisk), errors: errors, path: path, addItem: addItem, createDefault: this.innerCreateDefaultValue }),
            react_1.default.createElement("div", null, data > 0 ? (map_1.default(range_1.default(data), function (index) {
                return (react_1.default.createElement(ExpandPanelRenderer_1.default, { index: index, expanded: _this.isExpanded(index), schema: schema, path: path, handleExpansion: _this.handleChange, uischema: uischema, renderers: renderers, cells: cells, key: index, rootSchema: rootSchema, enableMoveUp: index != 0, enableMoveDown: index < data - 1, config: config, childLabelProp: appliedUiSchemaOptions.elementLabelProp, uischemas: uischemas }));
            })) : (react_1.default.createElement("p", null, "No data")))));
    };
    return MaterialArrayLayout;
}(react_1.default.PureComponent));
exports.MaterialArrayLayout = MaterialArrayLayout;
//# sourceMappingURL=MaterialArrayLayout.js.map